import { fetchApi } from './api'
import type { Throughput } from '../types/throughput'

/**
 * `GET api/observatory/throughput` — the hourly ETL throughput series.
 *
 * `hours` must be 1 to 168; anything else is a 400 from the server (refused,
 * never clamped), which `fetchApi` surfaces as an ApiError carrying the problem
 * detail. It is passed through unchanged for that reason: clamping it here would
 * draw a window the heading does not claim.
 */
export function getThroughput(hours: number): Promise<Throughput> {
  return fetchApi<Throughput>(`/api/observatory/throughput?hours=${encodeURIComponent(String(hours))}`)
}
